const _jsxFileName = "C:\\Users\\MartinStein\\Documents\\Development\\open.CHECK\\open.CHECKLIST\\src\\js\\custom_wehn\\components\\ArtikelInfoShow.tsx"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import * as React from "react";

import { observer } from "mobx-react-lite";
import {
  Alert,
  Descriptions,
  Divider,
  Empty,
  Image,
  PageHeader,
  Spin,
  Table,
  Tabs,
  Tag,
} from "antd";

import { ArtikelInfoShowState } from "./ArtikelInfoShow.state";






export const ArtikelInfoShow = observer(function ArtikelInfoShow({
  artikelId,
}) {
  const state = React.useMemo(
    () => new ArtikelInfoShowState(artikelId),
    [artikelId]
  );

  if (state.loading) return React.createElement(Spin, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 32}});
  if (!state.artikel) return React.createElement(Empty, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 33}});

  return (
    React.createElement('div', { style: { background: "#fff" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
      , React.createElement(PageHeader, {
        onBack: () => {
          window.history.back();
        },
        title: state.artikel.get("bezeichnung"),
        subTitle: state.artikel.get("artikelnummer"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
      )
      , React.createElement(Divider, { style: { marginTop: "0px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}})
      , React.createElement('div', { style: { padding: "10px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        , React.createElement('div', { style: { marginBottom: "10px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
          , state.dispostatus.anforderung && (
            React.createElement(Alert, { message: "Artikel ist angefordert"  , type: "info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}} )
          )
          , state.dispostatus.bestellt && (
            React.createElement(Alert, { message: "Artikel ist bestellt"  , type: "info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
          )
          , state.dispostatus.fertigung && (
            React.createElement(Alert, { message: "Artikel wird gefertigt"  , type: "info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}} )
          )
          , state.dispostatus.qs && (
            React.createElement(Alert, { message: "Artikel befindet sich in Freigabe"    , type: "info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}} )
          )
        )
        , React.createElement(Image, {
          width: "100%",
          height: 300,
          src: undefined, // TODO
          fallback: "data:image/png;base64,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", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        )
        , React.createElement(Divider, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, "Artikelinfo")
        , React.createElement(Descriptions, { bordered: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
          , React.createElement(Descriptions.Item, { label: "Artikelnummer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
            , state.artikel.get("artikelnummer")
          )
          , React.createElement(Descriptions.Item, { label: "Techniktext", span: 2, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
            , state.artikel.get("techniktext") ||
              "Kein technischen Angaben verfügbar"
          )
          , React.createElement(Descriptions.Item, { label: "Dispoart", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
            , state.artikel.get("dispoart") == "K" && "Kaufteil"
            , state.artikel.get("dispoart") == "E" && "Eigenfertigung"
            , state.artikel.get("dispoart") == "F" && "Fertigung ohne Lager"
            , state.artikel.get("dispoart") == "B" && "Beispielteil"
            , state.artikel.get("dispoart") == "H" && "Handlagerteil"
            , state.artikel.get("dispoart") == "L" &&
              "Leistung ohne Lieferschein"
          )
          , React.createElement(Descriptions.Item, { label: "Seriennummerpflichtig", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
            , state.artikel.get("seriennummer") ? "Ja" : "Nein"
          )
          , React.createElement(Descriptions.Item, { label: "Chargenpflichtig", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
            , state.artikel.get("chargenverfolgung") ? "Ja" : "Nein"
          )
          , React.createElement(Descriptions.Item, { label: "Zeichnung", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
            , (state.artikel.get("zeichnung") || "") +
              (state.artikel.get("zeichnungIndex") || "") || "Nicht vorhanden"
          )
        )
        , React.createElement(Divider, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "Lagerinfo")
        , React.createElement(Tabs, { defaultActiveKey: "1", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
          , React.createElement(Tabs.TabPane, { tab: "Bestände", key: "1", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
            , React.createElement(Table, {
              size: "small",
              dataSource: state.bestaende,
              rowKey: (row) => row.id,
              columns: [
                {
                  title: "Lager",
                  key: "lager",
                  render: (_, row) => {
                    return React.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}, _optionalChain([row, 'access', _2 => _2.get, 'call', _3 => _3("lager"), 'optionalAccess', _4 => _4.get, 'call', _5 => _5("sqlRef")]));
                  },
                },
                {
                  title: "Menge",
                  key: "menge",
                  render: (_, row) => {
                    const menge = _optionalChain([row, 'optionalAccess', _6 => _6.get, 'call', _7 => _7("bestandLaufend")]) || 0;
                    return (
                      React.createElement(Tag, { color: menge > 0 ? "green" : "red", __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}
                        , menge + " " + _optionalChain([state, 'access', _8 => _8.artikel, 'optionalAccess', _9 => _9.get, 'call', _10 => _10("mengeneinheit")])
                      )
                    );
                  },
                },
              ], __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
            )
          )
          , React.createElement(Tabs.TabPane, { tab: "Einlagerungen", key: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
            , React.createElement(Table, {
              size: "small",
              dataSource: state.einlagerungen,
              rowKey: (row) => row.id,
              columns: [
                {
                  title: "Lagerort",
                  key: "lagerort",
                  render: (_, row) => {
                    return (
                      React.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}
                        , displayLagerortSQLRef(
                          _optionalChain([row, 'optionalAccess', _11 => _11.get, 'call', _12 => _12("lagerort")]) 
                        )
                      )
                    );
                  },
                },
                {
                  title: "Menge",
                  key: "menge",
                  render: (_, row) => {
                    const menge = _optionalChain([row, 'optionalAccess', _13 => _13.get, 'call', _14 => _14("menge")]) || 0;
                    return (
                      React.createElement(Tag, { color: menge > 0 ? "green" : "red", __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
                        , menge + " " + _optionalChain([state, 'access', _15 => _15.artikel, 'optionalAccess', _16 => _16.get, 'call', _17 => _17("mengeneinheit")])
                      )
                    );
                  },
                },
              ], __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
            )
          )
          , React.createElement(Tabs.TabPane, { tab: "Buchungen", key: "3", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}
            , React.createElement(Table, {
              size: "small",
              dataSource: state.buchungen,
              rowKey: (row) => row.id,
              columns: [
                {
                  title: "Lager",
                  key: "lager",
                  render: (_, row) => {
                    return React.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}, _optionalChain([row, 'access', _18 => _18.get, 'call', _19 => _19("lager"), 'optionalAccess', _20 => _20.get, 'call', _21 => _21("sqlRef")]));
                  },
                },
                {
                  title: "Lagerort",
                  key: "lagerort",
                  render: (_, row) => {
                    return displayLagerortSQLRef(
                      _optionalChain([row, 'optionalAccess', _22 => _22.get, 'call', _23 => _23("lagerort")]) 
                    );
                  },
                },
                {
                  title: "Menge",
                  key: "menge",
                  render: (_, row) => {
                    const menge = _optionalChain([row, 'optionalAccess', _24 => _24.get, 'call', _25 => _25("menge")]) || 0;

                    return (
                      React.createElement(Tag, { color: menge > 0 ? "green" : "red", __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}
                        , menge + " " + _optionalChain([state, 'access', _26 => _26.artikel, 'optionalAccess', _27 => _27.get, 'call', _28 => _28("mengeneinheit")])
                      )
                    );
                  },
                },
              ], __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}
            )
          )
        )
      )
    )
  );
});

function displayLagerortSQLRef(lagerort) {
  try {
    return JSON.parse(_optionalChain([lagerort, 'optionalAccess', _29 => _29.get, 'call', _30 => _30("sqlRef")]) ).join("/");
  } catch (error) {
    return "";
  }
}
